import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import Icon from "@/components/Icon";
import api from "@/lib/api";

export default function PaymentReturn({ mode }) {
  const nav = useNavigate();
  const [state, setState] = useState(mode === "cancel" ? "cancel" : "polling");

  useEffect(() => {
    if (mode === "cancel") return;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (data.payment_status === "failed" || data.status === "expired") { setState("error"); return; }
      } catch { /* keep polling */ }
      if (++tries < 8) setTimeout(poll, 1800); else setState("timeout");
    };
    poll();
  }, [mode]);

  const M = {
    polling: { icon: "Loader2", spin: true, title: "Confirming your subscription...", sub: "Please wait while we verify with Stripe.", tint: "text-primary" },
    success: { icon: "CheckCircle2", title: "You're all set! 🎉", sub: "Your 1-month free trial has started. You won't be charged until the trial ends.", tint: "text-emerald-500" },
    cancel: { icon: "XCircle", title: "Checkout cancelled", sub: "No changes were made to your plan.", tint: "text-amber-500" },
    error: { icon: "AlertCircle", title: "Something went wrong", sub: "We couldn't confirm the payment. Please try again from Billing.", tint: "text-destructive" },
    timeout: { icon: "Clock", title: "Still processing", sub: "This is taking longer than usual. Your plan will update automatically once Stripe confirms.", tint: "text-amber-500" },
  }[state];

  return (
    <AppLayout>
      <div className="max-w-md mx-auto text-center py-16">
        <Icon name={M.icon} className={`h-14 w-14 mx-auto ${M.tint} ${M.spin ? "animate-spin" : ""}`} />
        <h1 className="text-2xl font-display font-extrabold mt-4">{M.title}</h1>
        <p className="text-muted-foreground mt-2">{M.sub}</p>
        <button data-testid="return-to-billing" onClick={() => nav("/app/billing")} className="mt-6 rounded-xl bg-primary text-primary-foreground px-6 py-2.5 text-sm font-bold hover:opacity-90">Go to Billing</button>
      </div>
    </AppLayout>
  );
}
